var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditProfileInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 17.2504C0.751544 14.9838 1.89011 12.8691 3.78149 11.62C5.67287 10.3708 8.06476 10.1539 10.15 11.0424",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 9C9.77817 9 11.625 7.15317 11.625 4.875C11.625 2.59683 9.77817 0.75 7.5 0.75C5.22183 0.75 3.375 2.59683 3.375 4.875C3.375 7.15317 5.22183 9 7.5 9Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 18C18.0784 18 18.75 17.3284 18.75 16.5C18.75 15.6716 18.0784 15 17.25 15C16.4216 15 15.75 15.6716 15.75 16.5C15.75 17.3284 16.4216 18 17.25 18Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5233 10.7002L18.9653 12.1532C19.1167 12.6536 19.6298 12.9512 20.1393 12.8342L21.6113 12.4932C22.184 12.3641 22.774 12.6231 23.0666 13.1321C23.3591 13.6411 23.2861 14.2812 22.8863 14.7112L21.8553 15.8222C21.4984 16.206 21.4984 16.8003 21.8553 17.1842L22.8863 18.2952C23.2861 18.7251 23.3591 19.3653 23.0666 19.8742C22.774 20.3832 22.184 20.6422 21.6113 20.5132L20.1393 20.1722C19.6298 20.0551 19.1167 20.3528 18.9653 20.8532L18.5233 22.3002C18.3546 22.8629 17.8368 23.2483 17.2493 23.2483C16.6619 23.2483 16.144 22.8629 15.9753 22.3002L15.5333 20.8472C15.382 20.3468 14.8688 20.0491 14.3593 20.1662L12.8873 20.5072C12.3146 20.6362 11.7246 20.3772 11.4321 19.8682C11.1395 19.3593 11.2126 18.7191 11.6123 18.2892L12.6433 17.1782C13.0003 16.7943 13.0003 16.2 12.6433 15.8162L11.6123 14.7052C11.2126 14.2752 11.1395 13.6351 11.4321 13.1261C11.7246 12.6171 12.3146 12.3581 12.8873 12.4872L14.3593 12.8282C14.8688 12.9452 15.382 12.6476 15.5333 12.1472L15.9753 10.6942C16.1453 10.1318 16.6641 9.74764 17.2515 9.74903C17.839 9.75041 18.356 10.137 18.5233 10.7002V10.7002Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileInactive);
export default __webpack_public_path__ + "static/media/edit-profile-Inactive.b72fe2fdd1be8d29468b1b31f38da3ef.svg";
export { ForwardRef as ReactComponent };